import { FinancialAccountNode } from './interfaces';
import { orgsRequest } from './request';

const GET_FINANCIAL_ACCOUNT_NODE_QUERY = `
  query FinancialAcctAcctId($acctId: ID!) {
    financialAcctAcctId(acctId: $acctId) {
      orgId
      orgName
      kybId
      finAcctId
      processor
      status
      acctId
      applicationId
      customerId
      createdAt
      updatedAt
      orgEin
      orgType
      stripeEnv
      paymentMethodId
    }
  }
`;

export const financialAcctId = async (
  acctId: string,
): Promise<FinancialAccountNode | undefined> => {
  const financialAcctIdRes = await orgsRequest(
    GET_FINANCIAL_ACCOUNT_NODE_QUERY,
    {
      acctId,
    },
  );
  const financialAcctIdJson = await financialAcctIdRes.json();
  if (
    financialAcctIdJson?.data?.financialAcctAcctId === undefined ||
    financialAcctIdJson?.data?.financialAcctAcctId.length === 0 ||
    financialAcctIdJson?.data?.financialAcctAcctId[0].kybId === undefined
  ) {
    throw new Error(`Could not find kybId from ${acctId}`);
  }
  return financialAcctIdJson.data.financialAcctAcctId[0];
};
